import { useState, useEffect, useCallback, useRef } from "react";
import UserService from "../../../services/UserService.js";
import LoaderSpin from "../../Layouts/Loader/LoaderSpin";
import AllUsers from "./AllUsers";
import Students from "./Students";
import Ciceis from "./Ciceis";
import Associated from "./Associated";
import Consultants from "./Consultants";
import Excludes from "./Excludes";
import Sintetics from "./Sintetics.jsx";
import { Row, Col, Divider, Tabs, Typography, message,Select,Space,Empty } from "antd";
import {
  TeamOutlined,
  MailOutlined,
  SolutionOutlined,
  FileSearchOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { selectCenterInformation } from "../../../Auth/centerInformationReducer.js";
import { selectUser } from "../../../Auth/userReducer.js";
import CoordinadorOfCenter from "./CoordinadorOfCenter.jsx";
import CenterService from "../../../services/CenterService.js";
import { selectInstituteInformation } from "../../../Auth/instituteInformationReducer.js";
import InstituteService from "../../../services/InstituteService.js";

const { TabPane } = Tabs;
const { Title } = Typography;

export default function UserAdmin() {
  const institute= useSelector(selectInstituteInformation);
  const {current: instituteSession}= useRef(institute);
  const center= useSelector(selectCenterInformation).centerInformation;
  const {current: centerSession}= useRef(center);
  const user= useSelector(selectUser);
  const {current: userSession}= useRef(user);
  const [centerSelected, setCenterSelected] = useState();
  const [instituteSelected, setInstituteSelected] = useState();
  const [selectOptionsVisible, setSelectOptionsVisible] = useState(false);
  const [userList, setuserList] = useState({});
  const [isLoading, setisLoading] = useState({
    status: "loading",
    message: "",
  });
  const [optionsSelectCenters,setOptionsSelectCenters]=useState()
  const [optionsSelectInstitutes,setOptionsSelectInstitutes]=useState()

  const handleOnChangeInstitute=(value)=>{
    setInstituteSelected(value)
    getCentersByInstitute(value)
    setCenterSelected()
  }

  const getListInstitute=(InstituteID)=>{
    InstituteService.getAllInstitutes(InstituteID).then((res)=>{
      if(res.data.success){
        let listInstitutes=res.data?.response;
        let List=[]
        listInstitutes.map((institute)=>{
          List.push({
            key: `KI=${institute.id}`,
            value: institute.id,
            label: `${institute.acronym} - ${institute.name}`,
          })
        })
        setOptionsSelectInstitutes(List)
        message.success("Lista de institutos cargada correctamente")
      }else{
        message.error("No se puedo obtener la lista de institutos")
      }
    })
  }  


  const getCentersByInstitute=useCallback((InstituteID)=>{
    CenterService.getListCentersByInstitute(InstituteID).then((res)=>{
      if(res.data.success){
        let listCenters=res.data?.response;
        let List=[]
        listCenters.map((center)=>{
          List.push({
            key: `KC=${center.id}`,
            value: center.id,
            label: `${center.acronym} - ${center.name}`,
          })
        })
        setOptionsSelectCenters(List)
        message.success("Lista de centros cargada correctamente")
      }else{
        message.error("No se puedo obtener la lista de centros")
      }
    })
  })

  const OptionsForRoles=()=>{
    let componentForRender = <Empty></Empty>;

      if (userSession.rolName==="Coordinador del instituto"){
        componentForRender= (<>
          <Divider>
            <Title level={4}>Opciones por {userSession.rolName}</Title>
          </Divider>
          <Row align={"center"}>
            <Select
            value={centerSelected}
            onChange={(value)=>{setCenterSelected(value)
            }}
            placeholder={"Seleccione un centro"}
            options={optionsSelectCenters}
            />
          </Row>
          </>)
      }
    
      if(userSession.rolName==="ANIDI - Director" || userSession.rolName==="Administrador"){
        componentForRender= (<>
          <Divider>
            <Title level={4}>Opciones por {userSession.rolName}</Title>
          </Divider>
          <Row align={"center"}>
            <Space >
              <Select
              value={instituteSelected}
              onChange={(value)=>{handleOnChangeInstitute(value)
            }
            }
              placeholder={"Seleccione un instituto"}
              options={optionsSelectInstitutes}
              />
              <Select
              value={centerSelected}
              onChange={(value)=>{setCenterSelected(value)
              }}
              placeholder={"Seleccione un centro"}
              options={optionsSelectCenters}
              />
            </Space>
          </Row>
          </>)
      }
    return componentForRender
  }
  
  const getUsers = useCallback((centerID) => {
    return new Promise((resolve, reject) => {
      console.log("centerSelectedGu",centerID)
      UserService.getUsersForAdmin(centerID)
        .then((res) => {
          if (res.data?.success) {
            let data = res.data?.response;
            let allUsers = data.filter(
              (u) => u.SystemRol.name !== "Administrador" && u.SystemRol.name !== "ANIDI - Director" && u.SystemRol.name !== "Coordinador del instituto" && u.state === true
            );
            let coordinador = data.filter(
              (u) => u.SystemRol.name === "Coordinador del centro" && u.state === true
            );
            let students = data.filter(
              (u) => u.SystemRol.name === "Estudiante" && u.state === true
            );
            let ciceis = data.filter(
              (u) => u.SystemRol.name === "Investigador" && u.state === true
            );
            let asociados = data.filter(
              (u) => u.SystemRol.name === "Asociado" && u.state === true
            );
            let consultores = data.filter(
              (u) => u.SystemRol.name === "Consultor" && u.state === true
            );
            let excludes = data.filter((u) => u.state === false);
            let sintetics = data.filter(
              (u) =>
                u.state === true && u.status === true && u.sintetic === true
            );
            resolve({
              allUsers,
              students,
              ciceis,
              asociados,
              consultores,
              excludes,
              sintetics,
              coordinador,
            });
          } else {
            reject({ status: "error", message: res.data?.response });
          }
        })
        .catch((e) => {
          reject({ status: "error", message: e.message });
        });
    });
  }, []);
  const runPromises_Sincro = useCallback(async () => {
    try {
      message.loading({
        content: "Actualizando...",
        key: "update",
        duration: 3,
      });
      let users = await getUsers();
      message.success({
        content: "Actualizado",
        key: "update",
        duration: 3,
      });
      setuserList(users);
    } catch (error) {
      message.error({
        content: "Error. " + error.message,
        key: "update",
        duration: 3,
      });
    }
  }, [getUsers]);

  const getData = useCallback((centerID) => {
    let promises = [getUsers(centerID)];
    Promise.allSettled(promises).then((results) => {
      let statusRequests = { status: "success", message: "" };
      results.forEach((result, index) => {
        if (result.status === "rejected") {
          statusRequests = result.reason || {
            status: "error",
            message: "Error desconocido",
          };
        } else {
          switch (index) {
            case 0:
              setuserList(result.value);
              break;
            default:
              break;
          }
        }
      });
      setisLoading(statusRequests);
    });
  }, [getUsers]);

  const getDataByRoles=()=>{
    let centerID;

    if(userSession.rolName==="ANIDI - Director"){
      setSelectOptionsVisible(true)
      getListInstitute()
      if(instituteSelected!=null){getCentersByInstitute(instituteSelected)}
      centerID=centerSelected
    }
    else{
      if(userSession.rolName==="Coordinador del instituto")
      {
        setSelectOptionsVisible(true)
        getCentersByInstitute(instituteSession.id)
        centerID=centerSelected
      }else{
        setCenterSelected(centerSession.id)
        centerID=centerSession.id
      }
    }
    return {centerID}
  }
  
  useEffect(() => {
    let {centerID}=getDataByRoles()
    getData(centerID);
  }, []);

  useEffect(() => {
    getData(centerSelected);
  }, [centerSelected]);

  if (isLoading.status === "loading" || isLoading.status === "error") {
    return <LoaderSpin isLoading={isLoading} />;
  }
  return (
    <>
    {
      selectOptionsVisible && (<OptionsForRoles/>)
    }
      <Divider>
        <Title level={4}>Usuarios</Title>
      </Divider>
      <Row justify="center">
        <Col span={23}>
          <Tabs defaultActiveKey="1" destroyInactiveTabPane={true}>
            <TabPane
              tab={
                <span>
                  <TeamOutlined />
                  Todos
                </span>
              }
              key="1"
            >
              <AllUsers
                list={userList.allUsers}
                getUsers={getUsers}
                setuserList={setuserList}
              />
            </TabPane>
            <TabPane
              tab={
                <span>
                  <MailOutlined />
                  Estudiantes
                </span>
              }
              key="2"
            >
              <Students list={userList.students} />
            </TabPane>
            <TabPane
              tab={
                <span>
                  <SolutionOutlined />
                  Investigadores
                </span>
              }
              key="3"
            >
              <Ciceis list={userList.ciceis} />
            </TabPane>
            <TabPane
              tab={
                <span>
                  <FileSearchOutlined />
                  Asociados
                </span>
              }
              key="4"
            >
              <Associated list={userList.asociados} />
            </TabPane>
            <TabPane
              tab={
                <span>
                  <FileSearchOutlined />
                  Consultores
                </span>
              }
              key="5"
            >
              <Consultants list={userList.consultores} />
            </TabPane>
            <TabPane
              tab={
                <span>
                  <FileSearchOutlined />
                  Sintéticos
                </span>
              }
              key="6"
            >
              <Sintetics
                list={userList.sintetics}
                runPromises={runPromises_Sincro}
              />
            </TabPane>
            <TabPane
              tab={
                <span>
                  <FileSearchOutlined />
                  Excluidos
                </span>
              }
              key="7"
            >
              <Excludes
                list={userList.excludes}
                getUsers={getUsers}
                setuserList={setuserList}
              />
            </TabPane>
            {(userSession.rolName==="Coordinador del instituto" ||userSession.rolName==="Coordinador del centro" || userSession.rolName==="Administrador"  || userSession.rolName==="ANIDI - Director")&&<TabPane
              tab={
                <span>
                  <FileSearchOutlined />
                  Coordinador
                </span>
              }
              key="8"
            >
              <CoordinadorOfCenter
                list={userList.coordinador}
                getUsers={getUsers}
                setuserList={setuserList}
              />
            </TabPane>}
          </Tabs>
        </Col>
      </Row>
    </>
  );
}
